export const getZipFromUrlHash = (): string | undefined =>
  (window.location.hash || "").match(/^#zip=(.*)/)?.[1];
